// <div data-controller="components--flash">
//
// </div>
import { Controller } from "@hotwired/stimulus";
import api from "@/utils/api";
import noonHappy from "@assets/images/noon/happy.png";
import noonWelcome from "@assets/images/noon/welcome.png";
import noonOops from "@assets/images/noon/oops.png";


export default class extends Controller {
  static targets = [ "container" ];
  static values = {
    key: String,
    message: String,
    ttl: Number // 3.0 업글 후 : ttl: { type: Number, default: 5 }
  };

  dismiss() {
    this.containerTarget.remove();
  }

  flashKeyToEmoji(flashKey) {
    switch(flashKey) {
      case 'success':
        return `<img src="${noonHappy}" class="h-5 w-5">`;
      case 'error':
        return `<img src="${noonOops}" class="h-5 w-5">`;
      case 'alert':
        return `<img src="${noonOops}" class="h-5 w-5">`;
      case 'warning':
        return `<img src="${noonOops}" class="h-5 w-5">`;
      case 'notice':
        return `<img src="${noonHappy}" class="h-5 w-5">`;
      default:
        return `<img src="${noonHappy}" class="h-5 w-5">`;
    }
  }

  flashTemplate(key, message) {
    return `<div class="max-w-sm w-full bg-white dark:bg-zinc-800 border border-zinc-200 dark:border-zinc-600 shadow-lg rounded-lg pointer-events-auto">
        <div class="rounded-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
          <div class="flex items-center">
              <div class="py-4 pl-4 shrink-0">${this.flashKeyToEmoji(key)}</div>
              <div class="p-4 w-0 flex-1">
                <p class="text-sm leading-5 font-medium text-gray-900 dark:text-gray-100">${message}</p>
              </div>
              <div class="shrink-0 flex">
                <button data-action="click->components--flash#dismiss"
                  class="p-4 cursor-pointer inline-flex text-gray-400 focus:outline-none focus:text-gray-500 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100 transition ease-in-out duration-150">
                  <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                  </svg>
                </button>
              </div>
            </div>
        </div>
    </div>`;
  }

  connect() {
    let template;
    template = this.flashTemplate(this.keyValue, this.messageValue);

    this.containerTarget.insertAdjacentHTML('beforeend', template)

    setTimeout(() => {
      this.dismiss();
    }, this.ttlValue * 1000)
  }
}